'use client'

import { useQueryClient } from '@tanstack/react-query'
import i18n from '@/i18n'
import { toast } from 'sonner'

import { useIndividualsServiceGetV1IndividualsByIndividualIdKey, useUsersServiceGetV1UsersMeKey } from '../client/queries/common'
import { useIndividualsServicePostV1IndividualsByIndividualIdRevokeAccess } from '../client/queries'

export const useRevokeIndividualAccess = () => {
  const queryClient = useQueryClient()
  const t = i18n.t

  return useIndividualsServicePostV1IndividualsByIndividualIdRevokeAccess({
    onMutate: () => {
      toast.loading(t('asyncToasts.revokeIndividualAccess.loading'), { id: 'revoke-access' })
    },
    onSuccess: async (_, { individualId }) => {
      await Promise.all([
        queryClient.invalidateQueries({ queryKey: [useUsersServiceGetV1UsersMeKey] }),
        queryClient.invalidateQueries({ queryKey: [useIndividualsServiceGetV1IndividualsByIndividualIdKey, { individualId }] }),
      ])
      toast.success(t('asyncToasts.revokeIndividualAccess.success'), { id: 'revoke-access' })
    },
    onError: () => {
      toast.error(t('asyncToasts.revokeIndividualAccess.error'), { id: 'revoke-access' })
    },
  })
}
